"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
const Loader = _react.default.memo(({
  internal = false,
  className
}) => _react.default.createElement(_styles.LoaderContainer, {
  className: className,
  internal: internal
}, _react.default.createElement(_styles.PositionContainer, null, _react.default.createElement(_styles.LoaderBox, {
  width: "90",
  height: "90"
}, _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
  id: "gradient"
}, _react.default.createElement(_styles.StartColorElement, {
  offset: "0%"
}), _react.default.createElement(_styles.StopColorElement, {
  offset: "100%"
}))), _react.default.createElement("path", {
  fill: "none",
  stroke: "url(#gradient)",
  strokeWidth: "11.25",
  transform: "translate(5.625,5.625)",
  d: "M 39.381872233894846 78.74999940028445 A 39.375 39.375 0 1 0 39.375 78.75"
})))));
Loader.propTypes = {
  internal: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = exports.default = Loader;